import ArticleHeader from 'components/article-header/ArticleHeader';
import { ContentWithSidebar, Content, Sidebar } from 'components/content-with-sidebar';
import PageNavigation from 'components/page-navigation/PageNavigation';
import NestedMenu from 'components/nested-menu/NestedMenu';
import RichText from 'components/rich-text/RichText';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import MetadataList from 'components/metadata-list/MetadataList';

import { ILargeArticlePage } from 'source/NFR.types';

const LargeArticlePage: React.FC<ILargeArticlePage> = ({
  title,
  image,
  content,
  header,
  pageNavigation,
  nestedMenu,
  metadata,
  isFrontPage
}) => {
  return (
    <>
      {image && (
        <div className="large-article-page--image">
          <Image {...imageSizes.largeArticlePage} {...image} />
        </div>
      )}
      <ContentWithSidebar theme="sidebarLeft" className="large-article-page--content" useContentContainer={false}>
        <Sidebar className="large-article-page--sidebar">
          <NestedMenu {...nestedMenu} />
          {metadata && <MetadataList {...metadata} />}
        </Sidebar>
        <Content className="large-article-page--content-main">
          {title && <h1 className="large-article-page--title">{title}</h1>}
          <RichText {...content} />
          {pageNavigation && <PageNavigation {...pageNavigation} isFirstPage={isFrontPage} isLargeArticle />}
          {header && <ArticleHeader {...header} isLargeArticle />}
        </Content>
      </ContentWithSidebar>
    </>
  );
};

LargeArticlePage.displayName = 'LargeArticlePage';

export default LargeArticlePage;
